<template lang="pug">
  .netherlands
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/holland-min.png"
      )
      span {{ gettext('Нидерланды') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Эта высокоразвитая и богатая страна, которая привлекает массу туристов из разных стран мира. Но также она весьма популярна и среди трудовых мигрантов, которые находят её очень комфортной для работы и жизни. Нидерланды являются членом Евро союза уже долгие годы, и благодаря её бурному, но в то же время рациональному развитию экономики, страна достигла высоких планок и входит в десятку самых богатых стран мира.') }}
        p {{ gettext('Также эта страна славится культурной составляющей: красивая разнообразная архитектура, знаменитые музеи, парки, активная молодежная жизнь и образование. Красивая и богатая природа поддерживается и облагораживается голландцами в самым трепетным образом. Нидерланды известны на весь мир своими тюльпановыми полями.') }}
        p {{ gettext('Экономику страны помогают развивать секторы промышленности электроники – (концерн Philips), химии и нефтехимии, сельского хозяйства и, соответственно, пищевой промышленности, машиностроения (автобусов и грузовиков DAF). В Голландии самое большое в мире количество теплиц, на которых выращиваются помидоры, огурцы, тюльпаны. Голландские продукты, в особенности молочные и мясные, считаются одними из самых высококачественных в мире. Торговля и сфера финансов также занимают центральные позиции в экономическом благосостоянии.') }}
        p {{ gettext('Многие голландцы свободно разговаривают на английском языке, поэтому вам не составит труда объясниться, тем более, что голландцы – открытый народ. Голландия очень безопасная страна с медициной высокого уровня.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/holland-min.png'})
  },
  name: 'Netherlands',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Netherlands | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/netherlands/index.vue